<template>
  <transition name="fade">
    <div class="modal-wrapper" v-if="!currentUser.sawUpdateModal">
      <transition name="modal" appear>
        <div class="modal">
          <header>
            <h1>КАЧЕН Е НОВ ЪПДЕЙТ</h1>
          </header>
          <main>
            <p>
              Вече може да подписвате заедно една, две или повече отпуски или отсъствия. Изберете от чекбокса желаните
              за подпис бланки и натиснете бутона "ПОДПИШИ ГРУПОВО ИЗБРАНИТЕ"
            </p>
            <a href="https://cdn.cdots.bg/kcm/gr-sign.pdf" target="_blank">
              <button>ПОВЕЧЕ ИНФОРМАЦИЯ ПРОЧЕТЕТЕ ТУК</button>
            </a>
            <img src="@/assets/img/update-info.png" alt="" />
            <p>Винаги може да прочетете упътването отново от бутона за помощ ❓, долу в десния ъгъл до вашето име.</p>
          </main>
          <footer>
            <button @click="close">ЗАТВОРИ</button>
          </footer>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['currentUser']),
  },
  data() {
    return {};
  },
  methods: {
    async close() {
      try {
        await this.$apiService.put(`/users/mark-as-seen`);
        this.currentUser.sawUpdateModal = true;
      } catch (error) {
        console.log(error);
        return this.$snotify.error('Нещо се обърка!');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/base.scss';
.modal-wrapper {
  align-items: center;
  background-color: #00000033;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;

  .modal {
    background-color: #ffffff;
    border-radius: 10px;
    color: #000000;
    max-height: calc(100% - 20px);
    max-width: calc(100% - 20px);
    padding: 15px 50px 15px;
    position: relative;
    @include noselect();

    header {
      color: #264d92;
      font-size: $px16;
      text-align: center;
    }

    main {
      display: flex;
      flex-wrap: wrap;
      text-align: center;
      gap: 10px;
      margin: 20px;
      max-width: 515px;
      max-height: 50vh;
      overflow: auto;
      @include scrollbar(5px, $mainColor);

      p {
        font-size: $px16;

        &:last-of-type {
          font-size: $px14;
        }
      }

      a {
        width: 100%;
      }
      button {
        color: #67aadd;
      }
    }

    footer {
      text-align: center;
    }
    button {
      align-items: center;
      background-color: transparent;
      border: none;
      color: #ff0000;
      cursor: pointer;
      display: inline-flex;
      font-size: $px14;
      font-weight: 600;
      text-decoration: underline;
      justify-content: center;
      text-align: center;
    }
  }
}

@media screen and (max-width: $s), (orientation: landscape) and (max-width: $landscape) {
  .modal-wrapper {
    .modal {
      main {
        button {
          width: 100%;
        }
      }

      footer {
        button {
          width: 100%;
        }
      }
    }
  }
}
</style>